import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import {
    Column,
    DataGrid,
    Sorting,
    Paging,
    Pager,
    LoadPanel,
    ColumnHeaderFilter,
    Selection,
    StateStoring,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
    Lookup,
    FilterRow,
    FilterPanel,
    GroupPanel,
    Grouping
} from "devextreme-react/data-grid";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import data from "../../../../../assets/apiRoutes.json";
import { GridLayout } from "../../../../../common/GridLayout";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";

function SublotsTab(props) {
    const dataGrid = useRef(null);

    var accessToken = props.oidc.user.access_token;
    const gridKey = "CC25B217-3125-460B-91D0-A3C2F88F5DBA";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const dataSource = useMemo(() => createStore({
        key: 'rowId',
        loadParams: {
            lotRowid: props.rowId
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/${data.Lot.GetSublotsByLot}`,
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`,
                Key: props.sourceId,
            };
        },
    }), [props.rowId]);

    return (
        <div className="FormMt">
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                allowColumnReordering={true}
                allowColumnResizing={true}
                dataSource={dataSource}
                showBorders={true}
                hoverStateEnabled={true}
                className={"GridHeightTabPanel-with-toolbar"}
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
            >
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <ColumnHeaderFilter />
                <LoadPanel enabled={true} />
                <Paging defaultPageSize={10} />
                <Sorting visible={true} mode="multiple" />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={[10, 20, 50, 300, 500, 'all']}
                    showNavigationButtons={true}
                />
                <Column dataType="string" dataField="subLotCode" caption="Sublot"></Column>
                <Column dataType="string" dataField="subLotDescription1" caption="Description - 1"></Column>
                <Column dataType="string" dataField="subLotDescription2" caption="Description - 2"></Column>
                <Column dataType="string" dataField="subLotStatus" caption="Status">
                    <Lookup
                        dataSource={[{ id: 'A', text: 'Active' }, { id: 'I', text: 'In Active' }]}
                        displayExpr="text"
                        valueExpr="id" />
                </Column>
                <Column dataType="date" dataField="dateIntroduce" caption="Introduced Dt"></Column>
                <Column dataType="date" dataField="dateAvailable" caption="Available Dt"></Column>
                <Column dataType="date" dataField="dateExpiration" caption="Expiration Dt"></Column>
                <Column dataType="string" dataField="locationCode" caption="Def Location"></Column>
                <Column dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} dataField="subLotOnHand" caption="Available"></Column>
                <Column dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} dataField="subLotOutUnavailable" caption="On Hand"></Column>
                <Column dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} dataField="subLotAvailable" caption="Unavailable"></Column>
                <Column dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} dataField="subLotNetAvailable" caption="Available"></Column>
                <Column dataType="string" dataField="recordNumber" caption="Record #" visible={false}></Column>
                <GridToolbar>
                    <GridToolbarItem location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </GridToolbarItem>
                    <GridToolbarItem name="exportButton" />
                    <GridToolbarItem name="columnChooserButton" />
                </GridToolbar>
            </DataGrid>
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(SublotsTab);